const BOARD_ID_REGEX = new RegExp("/board/(.*?)(?=/|$)");

export const extractBoardIdFromUrl = (url) => {
  const match = BOARD_ID_REGEX.exec(url);
  if (!match || match.length < 1) {
    return undefined;
  }
  return match[1];
};
